/*
 * This file is part of Invenio.
 * Copyright (C) 2016-2021 CERN.
 * Copyright (C) 2023 Northwestern University.
 *
 * Invenio is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

import React from "react";
import ReactDOM from "react-dom";
import { i18next } from "@translations/invenio_communities/i18next";

import CommunitiesCardGroup from "./CommunitiesCardGroup";

const userCommunitiesContainer = document.getElementById("user-communities");
const newCommunitiesContainer = document.getElementById("new-communities");

if (userCommunitiesContainer) {
  const fetchDataUrl = "/api/user/communities?q=&sort=newest&page=1&size=5";

  fetch(fetchDataUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();
    })
    .then(userCommunities => {

        // Extract slugs of communities from userCommunities
        const userCommunitySlugs = userCommunities.hits.hits.map((community) => community.slug);

        // Render CommunitiesCardGroup with userCommunities
        ReactDOM.render(
            <CommunitiesCardGroup
            communities={userCommunities}
            emptyMessage={i18next.t("You are not a member of any community.")}
            defaultLogo="/static/images/square-placeholder.png"
            />,
            userCommunitiesContainer
        );

        if (newCommunitiesContainer) {
          // Fetch data for 'new communities'
          fetch("/api/communities?q=&sort=newest&page=1&size=5")
            .then(response => {
              if (!response.ok) {
                throw new Error('Failed to fetch data');
              }
              return response.json();
            })
            .then(newCommunities => {

              // Filter out communities from newCommunities that are not in userCommunities
              const filteredNewCommunities = newCommunities.hits.hits.filter((community) => {
                return !userCommunitySlugs.includes(community.slug);
              });

              // Render the filtered 'new communities'
              ReactDOM.render(
                <CommunitiesCardGroup
                  communities={{"hits": {"hits": filteredNewCommunities}}}
                  emptyMessage={i18next.t("There are no new communities.")}
                  defaultLogo="/static/images/square-placeholder.png"
                />,
                newCommunitiesContainer
              );
            })
            .catch(error => {
              console.error('Error fetching data:', error);
            });
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  else {
    if (newCommunitiesContainer) {
        ReactDOM.render(
            <CommunitiesCardGroup
            fetchDataUrl="/api/communities?q=&sort=newest&page=1&size=5"
            emptyMessage={i18next.t("There are no new communities.")}
            defaultLogo="/static/images/square-placeholder.png"
            />,
            newCommunitiesContainer
        );
    }
}
